export enum Operation { //eslint-disable-line @stencil-community/ban-exported-const-enums
  DECREMENT,
  INCREMENT,
}

export const rerenderForceEvenetForLocalStorageChange = () =>
  document.dispatchEvent(new CustomEvent('comparison:local-storage-action'));

export const storeKeySetter = (country: string, language: string): string =>
  `svsProductComparisonList_${language}_${country}`;

export const storeGetter = (key: string): string[] => {
    const values = localStorage.getItem(key);

    if (values) {
      return values?.split(',');
    } else {
      return [];
    }
};

export const storeSetter = (
  operation: Operation,
  value: string,
  key: string
): void => {
    const storageValues = storeGetter(key);

    if ((!storageValues || storageValues?.length === 0) && operation) localStorage.setItem(key, value);

    operation && storageValues && storageValues?.length < 4
      ? localStorage.setItem(key, [...storageValues, value].join(','))
      : localStorage.setItem(
        key,
        storageValues?.filter((item) => item !== value)?.join(',')
      );

    rerenderForceEvenetForLocalStorageChange();
};

export const clearStore = (key: string): void => {
    localStorage.removeItem(key);
    rerenderForceEvenetForLocalStorageChange();
    window.dispatchEvent(new CustomEvent('compare:clear-list'));
};

export const getTabNameForDashboard = (isDashboardView: boolean, brand: string): string | void => {
    if (isDashboardView) return `${brand}/new_all`;
};
